export interface WellnessWheelCategory {
  enabled: boolean;
  categoryScore?: number;
}

export interface WellnessWheelProps {
  score: number;
  maxScore?: number;
  scoreColorOverride?: string;
  info?: WellnessWheelCategory;
  mentalHealth?: WellnessWheelCategory;
  health?: WellnessWheelCategory;
  lifestyle?: WellnessWheelCategory;
  vitals?: WellnessWheelCategory;
}

export interface WellnessWheelArcProps {
  arcColorFill?: string;
}

export interface WellnessWheelIconProps extends WellnessWheelArcProps {
  iconColorFill?: string;
}

export enum WellnessWheelScore {
  low = 20,
  medium = 60,
}
